import React from 'react'

export default function Termos() {
  return (
    <section className="about-section" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <div className="container" style={{ maxWidth: 960, display: 'grid', gap: 16 }}>
        <h1>Termos de Serviço – SIDES Mercado</h1>
        <p style={{ color: 'var(--text-light)' }}>Última atualização: 27 de Outubro de 2025</p>

        <p>
          Bem-vindo à plataforma SIDES Mercado, operada pela startup moçambicana de impacto social e tecnológico
          SIDES. Ao utilizar o site, aplicações móveis, serviços e funcionalidades associadas ao SIDES Mercado,
          o utilizador concorda com os seguintes Termos de Serviço:
        </p>

        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao aceder, navegar ou utilizar o SIDES Mercado, você reconhece que leu, compreendeu e concorda em
          cumprir estes Termos. Se não concordar com alguma parte, por favor não utilize a plataforma.
        </p>

        <h2>2. Objetivo da Plataforma</h2>
        <p>
          A SIDES Mercado atua como uma plataforma digital de intermediação entre produtores/agricultores
          locais (oferta) e consumidores/empresas (demanda). Nosso objetivo é fortalecer a economia local,
          facilitar o comércio justo e promover o consumo de produtos moçambicanos.
        </p>

        <h2>3. Cadastro e Conta de Utilizador</h2>
        <ul className="check-list">
          <li>Para realizar compras, é necessário criar uma conta com dados verdadeiros e atualizados.</li>
          <li>O utilizador é responsável por manter a confidencialidade da sua conta e senha.</li>
          <li>A SIDES pode suspender ou eliminar contas que infrinjam estes termos ou usem a plataforma de forma fraudulenta.</li>
        </ul>

        <h2>4. Produtos e Categorias</h2>
        <p>
          Os produtos estão organizados em categorias como Hortícolas, Frutas, Verduras; Peixes, Mariscos; Carnes,
          Aves; Cereais e outros produtos locais. Apenas produtos autênticos serão exibidos e comercializados.
        </p>

        <h2>5. Preços e Pagamento</h2>
        <ul className="check-list">
          <li>Todos os preços são apresentados em Meticais (MZN).</li>
          <li>Formas de pagamento: M‑Pesa, e‑Mola, Conta Móvel, Cartões, Transferência Bancária.</li>
          <li>A SIDES não armazena dados bancários ou de cartões.</li>
        </ul>

        <h2>6. Entregas e Retiradas</h2>
        <p>
          Os pedidos podem ser entregues no endereço indicado ou retirados localmente, quando disponível.
          Prazos e custos variam conforme a localização e fornecedor.
        </p>

        <h2>7. Cancelamentos e Reembolsos</h2>
        <ul className="check-list">
          <li>Cancelamentos só são aceitos antes da confirmação de envio.</li>
          <li>Produtos perecíveis não são reembolsáveis, exceto em caso de defeito comprovado.</li>
          <li>Suporte: <a href="mailto:info@govurb.co.mz">info@govurb.co.mz</a></li>
        </ul>

        <h2>8. Conduta do Utilizador</h2>
        <ul className="check-list">
          <li>Não utilizar a plataforma para fins ilegais.</li>
          <li>Não violar direitos de outros utilizadores ou produtores.</li>
          <li>Não tentar aceder indevidamente a servidores, APIs ou sistemas da SIDES.</li>
        </ul>

        <h2>9. Propriedade Intelectual</h2>
        <p>
          Todos os conteúdos (logotipos, textos, imagens, código) pertencem à SIDES Mercado ou seus licenciadores.
          É proibida a reprodução ou uso comercial sem autorização prévia por escrito.
        </p>

        <h2>10. Limitação de Responsabilidade</h2>
        <p>
          A SIDES atua como intermediadora e não é responsável por qualidade de produtos fornecidos por terceiros,
          atrasos por fatores externos ou uso indevido da plataforma por utilizadores.
        </p>

        <h2>11. Privacidade dos Dados</h2>
        <p>
          A coleta e uso de dados pessoais estão detalhados na {' '}
          <a href="/privacidade">Política de Privacidade</a>. Seguimos princípios do RGPD para garantir boas
          práticas, mesmo sem regulamentação nacional formal em Moçambique.
        </p>

        <h2>12. Modificações dos Termos</h2>
        <p>
          A SIDES reserva-se o direito de atualizar estes termos a qualquer momento. Mudanças importantes serão
          notificadas no site ou por e‑mail.
        </p>

        <h2>13. Legislação Aplicável</h2>
        <p>
          Estes Termos são regidos pela legislação da República de Moçambique, independentemente do local de acesso.
        </p>

        <h2>14. Contato e Suporte</h2>
        <p>
          📧 Email: <a href="mailto:info@govurb.co.mz">info@govurb.co.mz</a><br />
          📞 WhatsApp: <a href="https://wa.me/258852620360" target="_blank" rel="noreferrer">+258 85 262 0360</a><br />
          📍 Endereço: Rua da Frente de Libertação, Nº 56, Sommerschield – Maputo
        </p>
      </div>
    </section>
  )
}
